import { createAction, createReducer } from "@reduxjs/toolkit"
import { api } from "./helpers/api"
import { LOADING_INITIAL_STATE, setRequested, setReceived, setFailed } from "modules/loader-watchers/helpers/loading"

export const requestedExperiences = createAction("experiences/requested")
export const receivedExperiences = createAction("experiences/received")
export const failedExperiences = createAction("experiences/failed")
export const cleanedExperiences = createAction("experiences/cleaned")
export const requestedExperiencesByGuide = createAction("experiences/byGuide/requested")
export const receivedExperiencesByGuide = createAction("experiences/byGuide/received")
export const failedExperiencesByGuide = createAction("experiences/byGuide/failed")
export const cleanExperiencesByGuide = createAction("experiences/byGuide/clean")
export const requestedExperienceById = createAction("experiences/byId/requested")
export const receivedExperienceById = createAction("experiences/byId/received")
export const failedExperienceById = createAction("experiences/byId/failed")
export const requestedExperienceBookingData = createAction("experiences/bookingData/requested")
export const receivedExperienceBookingData = createAction("experiences/bookingData/received")
export const failedExperienceBookingData = createAction("experiences/bookingData/failed")
export const requestedEmbeddedCreateBooking = createAction("experiences/createBooking/requested")
export const receivedEmbeddedCreateBooking = createAction("experiences/createBooking/received")
export const failedEmbeddedCreateBooking = createAction("experiences/createBooking/failed")
export const requestedEmbeddedUpdateBooking = createAction("experiences/updateBooking/requested")
export const receivedEmbeddedUpdateBooking = createAction("experiences/updateBooking/received")
export const failedEmbeddedUpdateBooking = createAction("experiences/updateBooking/failed")
export const requestedEmbeddedCreatePaymentIntent = createAction("experiences/createPaymentIntent/requested")
export const receivedEmbeddedCreatePaymentIntent = createAction("experiences/createPaymentIntent/received")
export const failedEmbeddedCreatePaymentIntent = createAction("experiences/createPaymentIntent/failed")
export const requestedEmbeddedGetBookingDetailsById = createAction("experiences/getBookingDetailsById/requested")
export const receivedEmbeddedGetBookingDetailsById = createAction("experiences/getBookingDetailsById/received")
export const failedEmbeddedGetBookingDetailsById = createAction("experiences/getBookingDetailsById/failed")
export const updateBookingSelections = createAction("experiences/bookingSelections/update")
export const resetBookingSelections = createAction("experiences/bookingSelections/reset")
export const resetExperienceBookingData = createAction("experiences/bookingData/reset")

export const requestedEmail = createAction("experiences/email/requested")
export const receivedEmail = createAction("experiences/email/received")
export const failedEmail = createAction("experiences/email/failed")

const initialState = {
  ...LOADING_INITIAL_STATE,
  list: [],
  byGuide: {
    loading: false,
    error: null,
    data: [],
    metaData: {},
    guide:{
      adventureMode: "sportsman"
    }
  },
  experienceById: {
    loading: false,
    error: null,
    experienceDetail: {}
  },
  bookingInfo: {
    loading: false,
    error: null,
    data: {},
    guestToken: null
  },
  experienceBookingData: {
    loading: false,
    error: null,
    bookingData: {},
    bookingSelections: {
      date: null,
      counts: {
        main: {
          adults: 0,
          children: 0,
          infants: 0,
          passengers: 0
        },
        extra: {
          adults: 0,
          children: 0,
          infants: 0,
          passengers: 0
        }
      },
      tripLength: null,
      timeSlot: null,
      amount: 0,
      breakdown: null
    }
  },
  confirmedBookingData: {
    loading: false,
    error: null,
    data: {}
  }
}

const experiencesReducer = createReducer(initialState, {
  [requestedExperiences]: (state) => setRequested(state),
  [receivedExperiences]: (state, action) => {
    setReceived(state)
    state.list = action.payload
  },
  [failedExperiences]: (state) => setFailed(state),
  [cleanedExperiences]: () => initialState,
  [requestedExperiencesByGuide]: (state) => {
    state.byGuide.loading = true
    state.byGuide.error = null
  },
  [receivedExperiencesByGuide]: (state, action) => {
    state.byGuide.loading = false
    const newData = action.payload.data
    state.byGuide.data = [...state.byGuide.data, ...newData]
    state.byGuide.metaData = action.payload.metadata
    state.byGuide.adventureMode = action.payload.guide.adventure_mode
  },
  [failedExperiencesByGuide]: (state, action) => {
    state.byGuide.loading = false
    state.byGuide.error = action.payload
  },
  [cleanExperiencesByGuide]: (state) => {
    state.byGuide.error = {}
    state.byGuide.data = []
    state.byGuide.metaData = {}
    state.byGuide.adventureMode = ""
  },
  [requestedExperienceById]: (state) => {
    state.experienceById.loading = true
    state.experienceById.error = null
  },
  [receivedExperienceById]: (state, action) => {
    state.experienceById.loading = false
    state.experienceById.experienceDetail = action.payload.data
  },
  [failedExperienceById]: (state, action) => {
    state.experienceById.loading = false
    state.experienceById.error = action.payload
  },
  [requestedExperienceBookingData]: (state) => {
    state.experienceBookingData.loading = true
    state.experienceBookingData.error = null
  },
  [receivedExperienceBookingData]: (state, action) => {
    state.experienceBookingData.loading = false
    state.experienceBookingData.bookingData = {
      ...state.experienceBookingData.bookingData,
      ...action.payload
    }
  },
  [failedExperienceBookingData]: (state, action) => {
    state.experienceBookingData.loading = false
    state.experienceBookingData.error = action.payload
  },
  [requestedEmbeddedCreateBooking]: (state) => {
    state.bookingInfo.loading = true
    state.bookingInfo.error = null
  },
  [receivedEmbeddedCreateBooking]: (state, action) => {
    state.bookingInfo.loading = false
    state.bookingInfo.guestToken = action.payload.guest_token
    state.bookingInfo.data = {
      ...state.bookingInfo.data,
      ...action.payload
    }
  },
  [failedEmbeddedCreateBooking]: (state, action) => {
    state.bookingInfo.loading = false
    state.bookingInfo.error = action.payload
  },
  [requestedEmbeddedUpdateBooking]: (state) => {
    state.bookingInfo.loading = true
    state.bookingInfo.error = null
  },
  [receivedEmbeddedUpdateBooking]: (state, action) => {
    state.bookingInfo.loading = false
    state.bookingInfo.data = {
      ...state.bookingInfo.data,
      ...action.payload
    }
  },
  [failedEmbeddedUpdateBooking]: (state, action) => {
    state.bookingInfo.loading = false
    state.bookingInfo.error = action.payload
  },
  [requestedEmbeddedGetBookingDetailsById]: (state) => {
    state.confirmedBookingData.loading = true
    state.confirmedBookingData.error = null
  },
  [receivedEmbeddedGetBookingDetailsById]: (state, action) => {
    state.confirmedBookingData.loading = false
    state.confirmedBookingData.data = {
      ...action.payload
    }
  },
  [failedEmbeddedGetBookingDetailsById]: (state, action) => {
    state.confirmedBookingData.loading = false
    state.confirmedBookingData.error = action.payload
  },
  [updateBookingSelections]: (state, action) => {
    state.experienceBookingData.bookingSelections = {
      ...state.experienceBookingData.bookingSelections,
      ...action.payload
    }
  },
  [resetBookingSelections]: (state) => {
    state.experienceBookingData.bookingSelections = initialState.experienceBookingData.bookingSelections
  },
  [resetExperienceBookingData]: (state) => {
    state.experienceBookingData = initialState.experienceBookingData
  },
  [requestedEmail]: (state) => setRequested(state),
  [receivedEmail]: (state, action) => {
    setReceived(state)
    state.list = action.payload
  },
  [failedEmail]: (state) => setFailed(state)
})

export default experiencesReducer

export const createEmail = (data) => (dispatch) => {
  return dispatch(
    api({
      url: "/user/send_invitation_email",
      data,
      method: "post",
      onStart: requestedEmail.type,
      onSuccess: receivedEmail.type,
      onError: failedEmail.type
    })
  )
}

export const fetchExperiences = (list_for) =>
  api({
    url: "/guide/trips/embedded_experiences_list" + (list_for ? `?list_for=${list_for}` : ""),
    onStart: requestedExperiences.type,
    onSuccess: receivedExperiences.type,
    onError: failedExperiences.type
  })

export const fetchExperiencesByGuide = (uuid, date, page = 1) =>
  api({
    url: `/embedded_experiences?guuid=${uuid}&page=${page}&date=${date}`,
    onStart: requestedExperiencesByGuide.type,
    onSuccess: receivedExperiencesByGuide.type,
    onError: failedExperiencesByGuide.type
  })

export const fetchExperienceById = (id, b_uuid, embedded) => {
  let url = `/embedded_experiences/${id}?include_unavailable_dates=true`

  if (b_uuid) {
    url += `&b_uuid=${b_uuid}`
  }

  if (!embedded) {
    url += "&embedded=true"
  }

  return api({
    url,
    onStart: requestedExperienceById.type,
    onSuccess: receivedExperienceById.type,
    onError: failedExperienceById.type
  })
}

export const fetchExperienceBookingDetails = (id, type, trip_duration, date, bookingId, embedded) =>
  api({
    url: `embedded_experiences/${id}/booking_details?type=${type}&trip_price_id=${trip_duration ?? ""}&booking_date=${
      date ?? ""
    }&b_uuid=${bookingId}${!embedded ? "&embedded=true" : ""}`,
    onStart: requestedExperienceBookingData.type,
    onSuccess: receivedExperienceBookingData.type,
    onError: failedExperienceBookingData.type
  })

export const createEmbeddededBooking = (data) => (dispatch) => {
  return dispatch(
    api({
      url: `/embedded_experiences`,
      data,
      method: "post",
      onStart: requestedEmbeddedCreateBooking.type,
      onSuccess: receivedEmbeddedCreateBooking.type,
      onError: failedEmbeddedCreateBooking.type
    })
  )
}

export const updateEmbeddededBooking = (bookingId, data) => (dispatch) => {
  return dispatch(
    api({
      url: `/embedded_experiences/${bookingId}`,
      data,
      method: "put",
      onStart: requestedEmbeddedUpdateBooking.type,
      onSuccess: receivedEmbeddedUpdateBooking.type,
      onError: failedEmbeddedUpdateBooking.type
    })
  )
}

export const createPaymentIntent = (bookingId, guestToken) => (dispatch) => {
  return dispatch(
    api({
      url: `trip_bookings/${bookingId}/payments`,
      method: "post",
      guestToken,
      onStart: requestedEmbeddedCreatePaymentIntent.type,
      onSuccess: receivedEmbeddedCreatePaymentIntent.type,
      onError: failedEmbeddedCreatePaymentIntent.type
    })
  )
}

export const capturePayment = (bookingId, recordId) => (dispatch) => {
  return dispatch(
    api({
      url: `/trip_bookings/${bookingId}/payments/${recordId}/capture`,
      method: "put"
    })
  )
}

export const getBookingDetailsById = (bookingId) => (dispatch) => {
  return dispatch(
    api({
      url: `/trip_bookings/${bookingId}?include_stripe_cards=true`,
      onStart: requestedEmbeddedGetBookingDetailsById.type,
      onSuccess: receivedEmbeddedGetBookingDetailsById.type,
      onError: failedEmbeddedGetBookingDetailsById.type
    })
  )
}
